import React, { useEffect, useContext, useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { useHistory } from "react-router-dom";
import getEncodedImageUrl from '../../helpers/get-encoded-image';
import { EslidesEvent, Presentation } from '../../types/presentation';
import QuizFooter from '../speaker-mode/quiz-footer';
import axios, { AxiosResponse } from "axios";
import SocketClient from '../../helpers/connection';
import EventContext from "../../contexts/event";
import UserContext from "../../contexts/user";
import {useSubscription} from "@apollo/client";
import {quiz_actions, quiz_users} from "../../gql/quiz-gql";
import {Socket} from "socket.io-client/build/esm-debug";
import {useIntl} from "react-intl";

const ScreenUserList: React.FC<{ locale: string; setLocale: any; ppt: Presentation; event: EslidesEvent;client:Socket }> = ({ locale, setLocale, ppt, event,client }) => {

  const connectedUsers = 10;

  const [users, setUsers] = useState<String[]>([]);
  const [code, setCode] = useState("000000");
  const history = useHistory();
  const intl = useIntl();
  const eventContext = useContext(EventContext);
  const userContext = useContext(UserContext);
  const [actionData, setActionData] = useState({
    action: undefined,
    answered_count:undefined,
    id:undefined,
    presentation_id:undefined,
    question_index:undefined
  });
  const [loginData, setLoginData] = useState({
    name: undefined,
    code:undefined,
  });

  useEffect(()=>{
    // client.emit('join', {presentationId:ppt._id}, (response:any) => {
    //   console.log("join",response); // ok
    // });
  },[])


  useEffect(() => {
    // API CALL : for getting the quiz event code for login purpose
    // eslint-disable-next-line react-hooks/exhaustive-deps
    axios({
      method: "POST",
      //url: 'http://localhost:4000/stage/api/quiz/get-code',
      url: `${process.env.REACT_APP_API_ENDPOINT}/api/quiz/get-code`,
      data: {
        _id: ppt._id,
      },
    }).then((res) => {
      try {
        if (res.data.statusCode === 200) {
          setCode(res.data.code)
        }
      } catch (e) {

      }
       console.log("QUIZ LOGIN", res);

    });
    localStorage.setItem(
        `connected_users`,
        '0'
    );  localStorage.setItem(
        `answered_users`,
        '0'
    );

    configSocket();
  }, []);

  function configSocket() {
     // socket action get message callback
    client.on('quiz-action-updates', function (data:any){
      setActionData(data);
      console.log('quiz-action-updates------ 1',data);
    });

    // socket login get message callback
    client.on('quiz-user-login', function (data:any){
      setLoginData(data);
      console.log('quiz-action-updates------ 1',data);
    });
  }

  // set quiz question data
  useEffect(() => {
    if(actionData){
      let type= actionData.action;
      if (type === 'start_quiz') {
        history.push(
            `/${eventContext.slug}/${ppt._id}/screen-questions`
        )
      }
      console.log("EVENT_CHANGE",actionData.action)
    }
  }, [actionData]);

  useEffect(() => {
    if(loginData){
      if(loginData.name!==undefined){
        // @ts-ignore
        updateUser(loginData.name)
      }
    }
    console.log('quiz-action-updates------ 1',loginData,users);
  }, [loginData]);

  // update user-list with new value
  function updateUser(name: String) {
    setUsers((prev) => [...prev,...[name]]);
  }

  useEffect(() => {
    localStorage.setItem(
        `connected_users`,
        (users.length).toString()
    );
  }, [users]);

  return (

    <div className="quiz-home-page-container " style={{ minHeight: '100%' }}>
      <div className="quiz-home-header m-t-20">
        <Container fluid>
          <Row className='p-2' >
            <Col className="text-md-left text-center p-l-2" md={2} >  {event?.logo ?
              <img
                height={100}
                src={getEncodedImageUrl(event.logo, 90, 90, "contain")}
                alt="logo"
              /> : <img src="/images/logo-default.png" alt="logh" />
            }      </Col>
            <Col className="text-center">
              <img className="m-t-10" height={140} src="/images/tutorial-1.svg" alt="quiz" />
              <h4 className="quiz-home-title">Quiz</h4></Col>
            <Col className="text-md-right p-t-30" md={2} ><h5 style={{ textAlign: 'center' }}>{ppt.name}</h5></Col>
          </Row>
        </Container>
      </div>
      <div className="quiz-home-body ">
        <Container>
          <Row>
            <Col lg={10} xl={8} md={12} className="mx-auto text-center">
              <p className="quiz-body-text">
                {intl.formatMessage({id: 'quiz.link.msg'})}<br />
              </p>
              <p className="quiz-body-text"><span>{`${process.env.REACT_APP_QUIZ}`}/{eventContext.slug}</span></p>
              <p> {intl.formatMessage({id: 'quiz.code.msg'})}  <br />  <span className="quiz-code">{code}</span></p>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="conntected-users-container">
        <div className="conntected-users-count">
          <div className="count-header">

            <span>{users.length} {intl.formatMessage({id: 'quiz.connected'})}</span>

          </div>
        </div>

        <div className="list-of-connected-users">
          <ul>
            {users.map(value => {
              return (
                <li >{value}</li>
              )
            })}

          </ul>
        </div>

      </div>
      <Container fluid className={`mt-auto`}>
        <QuizFooter presentationId={ppt._id} screenMode={true} />
      </Container>
    </div>
  )
}

export default ScreenUserList;



